import React from 'react';
import {ServiceDetails} from "~/types";
import classes from './style.module.scss';
import useTranslation from "~/app/hooks/useTranslation";
import Icon from "~/app/common/Icon";
import moment from 'moment';

export interface ServiceProps {
    service: ServiceDetails
}

export type ServiceComponent = React.FC<ServiceProps>

const Service: ServiceComponent = ({service}) => {
    const {t} = useTranslation("service");
    return (
        <div className={classes['service-info']}>
            <div className={classes['info-wrapper']}>
                <div className={classes['title']}>{`${service.intervalTypeText} Service`}</div>
                <div className={classes['value']}>{`${t('createdAt')} ${moment(service.createdAt).format("DD.MM.YYYY")}`}</div>
                <div className={classes['title']}>{t("statusTitle")}</div>
                <div className={classes['value']}>
                    <Icon name="stop_circle" className={`${classes['status']} ${classes[service.status]}`}/>
                    {t(`statuses.${service.status}`)}
                </div>
                <div className={classes['title']}>{t("dueHoursText")}</div>
                <div className={classes['value']}>{service.dueHours ?? (service.dateDiff ? service.dateDiff + ' d' : '')}</div>
                <div className={classes['title']}>{t("interval")}</div>
                <div className={classes['value']}>{service.serviceText}</div>
                <div className={classes['title']}>{t("serviceProgram")}</div>
                <div className={classes['value']}>{service.serviceProgramName}</div>
                {service.departmentId && <div className={classes['info-wrapper']}>
                    <div className={classes['title']}>{t("department")}</div>
                    <div className={classes['value']}>{service.departmentName}</div>
                </div>}
            </div>
            <hr className={classes['bottom-line']}/>
        </div>
    );
};

export default Service
